import * as $ from "jquery";
import setupValidation from "../../../form-services/validation-setup-service";
import { submitForm } from "../../../form-services/submit-service";
import { Subscription } from "rxjs";
import "./form.less";
import { DateTimePickerService } from "../../../datetime-picker/datetime-picker.service";
import { getUID } from "../../../utility/key-generator";
import { RecaptchaService } from "../../../page-services/recaptcha-service";
import { WebClient } from "../../../webclient/webclient.service";
import { ValidationService } from "../../../form-services/validation-service";
import MaskService from "../../../form-services/form-mask.service";
import { AddRemoveList } from "../list/add-remove-list/add-remove-list-common";
import { FileInputCommon } from "../simple/file-input/file-input-common";
import { FileListInputCommon } from "../list/file-list-input/file-list-input-common";
import { DropdownCommon } from "../list/dropdown/dropdown-common";


declare global {
  interface JQuery {
    modal(any): any
  }
}

export class FormCommon {
  static subscriptions: Array<Subscription> = [];


  public static initForms() {

    FormCommon.initModal();

    ValidationService.init();
    if (!(self as any).grecaptcha) RecaptchaService.setupRecaptcha();
    else RecaptchaService.initCaptchas();


    FormCommon.subscriptions.forEach(s => s.unsubscribe());
    //FormCommon.setupComponents();
    let promises = [];
    $('.form-component').each((i, c) => {
      let comp = $(c);
      let formId = comp.attr("data-form-id");

      if (+formId > -1 && comp.find('form').length == 0) {
        let p = WebClient.getFormFrontend(formId);
        promises.push(p);
        p.then(
          form => {
            comp.html(form.content_html);
            comp.find(`input[type=hidden][name=form_id]`).val(formId);
          }
        );
      }
    });

    $.when.apply($, promises).then(FormCommon.setupComponents);
  }

  private static setupComponents() {
    RecaptchaService.initCaptchas();
    MaskService.initMasks();
    FormCommon.initAddRemove();
    $(".form-builder-form").each((i, frm) => {
      if ($(frm).closest(".editor-container").length == 0) {
        let name = "form_" + getUID();
        $(frm).attr("name", name);
        FormCommon.subscriptions.push(
          setupValidation(`form[name=${name}]`)
            .filter(ev => ev.event == "submit")
            .filter(ev => FormCommon.additionalValidation(name))
            .switchMap(() => submitForm(frm, FormCommon.addFiles(name)))
            .subscribe(res => FormCommon.handleResult(res, name), err => FormCommon.handleError(err))
        );
        FormCommon.initDefaults(name);
      }
    });

  }


  private static additionalValidation(formName) {
    return FileListInputCommon.validateAll();
  }

  private static addFiles(formName) {

    $('.temporary-file-input').remove();
    let data = [];
    $(`form[name=${formName}] .file-uploader-list-component`).each((i, comp) => {
      let c = $(comp);
      let name = c.attr('data-fileinput-name');
      if (name) {
        let files = FileListInputCommon.getFiles(name);
        let isImageUploader = c.attr('data-cropper') == 'true';
        if (files) {
          if (isImageUploader) {
            data = data.concat(files.map(file => ({
              //field: name, data: JSON.stringify({ name: file.name, base64Img: file.base64Img })
              field: name, data: file.serverName
            })))
          }
          else
            data = data.concat(files.map(file => ({ field: name, data: file })));
        }
      }
    });
    return data;
  }

  private static initDefaults(name) {

    //init select default values
    $(`form[name=${name}] .form-builder-input select`).each((i, select) => {
      let s = $(select);
      s.attr("value", s.attr("data-default-value"));
    });

    $(
      `form[name=${name}] .form-builder-input select, form[name=${name}] .form-builder-input input, form[name=${name}] .form-builder-input texterea`
    ).change(ev => {
      //console.log(ev.target.value);
    });

    //checkbox init
    $(document).off('click', `form[name=${name}] .form-builder-input .form-check-label span:not(.error)`);
    $(document).on('click', `form[name=${name}] .form-builder-input .form-check-label span:not(.error)`, ev => {
      let input = $(ev.target)
        .closest(".form-check-label")
        .find('input[type="checkbox"]');
      input.attr("data-dirty", 'true');
      if (!input.prop('checked')) {
        let val = input.attr('data-value');
        if (val)
          input.val(val);
      }
      else
        input.val('');
      input.click();

    });

    $(`form[name=${name}] input[type="checkbox"]`).prop('checked', false).closest('.form-check-label').removeClass('checked');
    $(`form[name=${name}] input[type="checkbox"][data-default-value=true]`).each((i, inp) => {
      let input = $(inp);
      let val = input.attr('data-value');
      if (val)
        input.val(val);
      //input.click();
      input.prop("checked", true).addClass('checked');
    })

    //radio group init
    $(document).off('click', `form[name=${name}] .form-builder-input .radio-input span:not(.error)`);
    $(document).on('click', `form[name=${name}] .form-builder-input .radio-input span:not(.error)`, ev => {

      let input = $(ev.target)
        .closest(".radio-input")
        .find('input[type="radio"]');
      let inputs = $(ev.target)
        .closest(".radio-group")
        .find('input[type="radio"]');
      inputs.removeAttr("checked").removeClass('checked');
      input.prop("checked", true).addClass('checked');
    });

    $(`form[name=${name}] .form-builder-input .radio-input input[type="radio"]`).prop("checked", false).removeClass("checked");
    $(`form[name=${name}] .form-builder-input .radio-group`).each((i, gr) => {
      let group = $(gr);
      let defaultValue = group.attr("data-default-value");
      if (defaultValue) {
        $(`form[name=${name}] .form-builder-input .radio-input input[type="radio"][value="${defaultValue}"]`)
          .closest('.radio-input').find('span:not(.error)').trigger('click');
      }
    }

    )

    //datetime picker init

    $(`form[name=${name}] .form-builder-input .form-builder-date-picker`).each((i, dp) => {
      let d = $(dp);
      let minDate = d.attr("data-min-date");
      let maxDate = d.attr("data-max-date");
      let defaultDate = d.attr("data-default-date");
      let showTimePicker = d.attr("data-time-picker") == "true";
      let format = d.attr("data-date-format");
      DateTimePickerService.initDateTimePicker({
        input: d.find("input").get(0),
        minDate,
        maxDate,
        defaultDate,
        showTimePicker,
        dateFormat: format
      });
    });

    //slider int
    $(document).off(
      "change",
      `form[name=${name}] .form-builder-input .slider-container input[type=range]`
    );
    $(document).on(
      "change",
      `form[name=${name}] .form-builder-input .slider-container input[type=range]`,
      ev => {
        let inp = $(ev.target);
        inp
          .closest(".slider-container")
          .find(".slider-value")
          .text(inp.val().toString());
      }
    );

    //file upload init
    $(`form[name=${name}] .file-uploader-component`).each((i, comp) => {
      FileInputCommon.initFileUpload(comp);
    });

    $(`form[name=${name}] .file-uploader-list-component`).each((i, comp) => {
      FileListInputCommon.initFileUpload(comp);
    });

    $(`form[name=${name}] .dropdown-component`).each((i, comp) => {
      DropdownCommon.init(comp);
    });
  }

  //product add / remove
  static initAddRemove() {
    $('.add-remove-list-component').each((i, el) => {
      let list = new AddRemoveList();
      list.initFrontend(el);
    })
  }

  static initModal() {
    if ($('.form-result-modal').length == 0)
      $("body").append(FormCommon.modalTemplate);
  }

  static checkMinFileSize(file, min) {
    return file.size * 1024 * 1024 >= min;
  }

  static checkMaxFileSize(file, max) {
    return file.size * 1024 * 1024 <= max;
  }



  private static addProtocol(url) {
    if (url.indexOf('//') == -1) {
      return '//' + url;
    }
    return url;
  }


  private static redirect(resp) {
    if ((resp as any).redirect_url)
      location.href = FormCommon.addProtocol((resp as any).redirect_url);
  }

  private static reset(name) {
    ValidationService.resetForm(`form[name=${name}]`);
    RecaptchaService.reset();

    let form = $(`form[name=${name}]`);
    form.find('.files-list li').remove();
    FileInputCommon.reset(name);
    FileListInputCommon.reset(name);
    FormCommon.initDefaults(name);
  }


  private static showResult(title, content, closeCallback?) {
    let modal = $(".form-result-modal");
    modal.find(".title").html(title);
    modal.find(".message").html(content);
    if (closeCallback) {
      modal.on('hidden.bs.modal', function () {
        modal.off('hidden.bs.modal')
        closeCallback();
      })
    }
    modal.modal('show');
  }


  private static handleError(err) {
    FormCommon.showResult("Error", "Error sending form! " + err.statusText);
    console.log(err);
  }


  private static handleResult(res, name) {

    if ((res as any).success) {
      FormCommon.reset(name);
      let title = (res as any).modal_title
        ? (res as any).modal_title
        : "";
      let content = (res as any).modal_content
        ? (res as any).modal_content
        : "";
      if (title.length > 0 || content.length > 0) {
        FormCommon.showResult(title, content, () => FormCommon.redirect(res));
      }
      else {
        FormCommon.redirect(res);
      }
    } else {

      FormCommon.showResult("Error", "Error sending form!");
    }
  }

  private static modalTemplate = `
    <div class="modal fade form-result-modal">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                <h3 class="title"></h3>
                    <button type="button" class="close" data-dismiss="modal">
                        <span class="mdi mdi-close"></span>
                    </button>
                    
                </div>
            <div class="modal-body">
                <div class="message"></div>
            </div>
            <div class="modal-footer">
                <button type="button" class="button type-2 toRight" data-dismiss="modal">OK</button>
            </div>
        </div>
    </div>`;
}
